import { useMutation, useQueryClient } from '@tanstack/react-query'

import API from '../../services/api'

// hooks
import useAnalytics from '../helper/useAnalytics'
import surfaceKeys from '../surface/_queryKeys'
import formulaKeys from './_queryKeys'

const useFormulaApprove = (formulaId) => {
    const queryClient = useQueryClient()

    const { track } = useAnalytics()

    return useMutation({
        mutationFn: API.approveFormula,
        onError: (err, approvedFormula, context) => {
            queryClient.setQueryData(
                formulaKeys.formulaById(formulaId),
                context.previousFormulaData,
            )
        },
        onSuccess: (data) => {
            track('formula_approved', {
                formula_id: formulaId,
            })
            queryClient.setQueryData(
                formulaKeys.approvedFormulaById(formulaId),
                data.data,
            )
            queryClient.invalidateQueries({ queryKey: surfaceKeys.all() })
        },
    })
}

export default useFormulaApprove
